import React, { useState } from "react";
import {
  Text,
  Image,
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
  Platform,
  Linking,
  Pressable,
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import { useNavigation } from "@react-navigation/native";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import InviteWebHeader from "../../components/InviteWebHeader";
import FooterBarWide from "../../components/footerBarWide";
import BackButtonTopWhite from "../../components/BackButtonTopWhite";
import { Checkbox } from "react-native-paper";
import AsyncStorage from "@react-native-async-storage/async-storage";
// import { backgroundColor } from "react-native/Libraries/Components/View/ReactNativeStyleAttributes";
// import { FontAwesome } from "@expo/vector-icons";
import { promoDataReset } from "../../redux/actions/PartnerActions";
import GenericButton from "../../components/GenericButton.js";

export default function RedeemLandingScreen() {
  const BGimage = require("../../assets/res/blue_bg.png");
  const MenuLogo = require("../../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  const shellLogo = require("../../assets/images/shell/shellIcon.png");
  const saveIcon = require("../../assets/images/shell/saveIcon.png");
  const navigation = useNavigation();
  const [checked, setChecked] = useState(false);
  const win = Dimensions.get("window");

  const skipShellLandingScreen = () => {
    const val = AsyncStorage.getItem("skipShellLandingScreen");
    // console.log(val);
    return val;
  };

  promoDataReset();

  skipShellLandingScreen().then((value) => {
    if (value == "truthy") {
      navigation.navigate("ShellBarcode");
    }
  });

  // if (skipShellLandingScreen() == "truthy") {
  //   navigation.navigate("ShellBarcode");
  // } else {
  //   console.log(skipShellLandingScreen());
  //   console.log((skipShellLandingScreen() == "truthy"));
  // }
  // function onCheckmarkPress() {
  //     onChange(!checked);
  // }
  return (
    <ScrollView style={styles.scrollView}>
      <View style={[GlobalStyles.containerN, { backgroundColor: "#ffffff" }]}>
        {/* <View style={GlobalStyles.backgroundContainer}>
                <Image style={GlobalStyles.backgroundImage} source={BGimage} />
            </View> */}
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="1" />
            <View style={GlobalStyles.headerContainerKLYellow}></View>
          </View>
        ) : (
          <View style={GlobalStyles.shellMobileHeaderContainer}>
            <View style={styles.backButtonContainer}>
              <BackButtonTopWhite />
            </View>
            <View style={styles.mainMenuLogoContainer}>
              <Image style={styles.mainMenuLogo} source={MenuLogo} />
            </View>
            <View style={styles.forwardButtonContainer}></View>
          </View>
        )}
        <View style={styles.bodyContainerFull}>
          <View style={styles.fuelPartnerTextContainer}>
            <Text style={styles.fuelPartnerTextStyle}>Fuel Partner</Text>
          </View>
          <View style={styles.ShellLogoContainer}>
            <Image style={styles.shellLogo} source={shellLogo} />
          </View>
          <View style={styles.boldTextContainer}>
            <Text style={styles.textStyleBold}>
              Up to 17¢ per litre of rewards & discounts available when combining the 3 offers.#^
            </Text>
          </View>
          <View style={styles.threeLogoContainer}>
            <Image style={styles.saveIconLogo} source={saveIcon} />
          </View>
          <View style={styles.termTextContainer}>
            <Text style={styles.textStyle}>
              *3¢ per litre deposited from your qualifying Shell fuel purchase into your Aura account.
            </Text>
          </View>
          <View style={styles.termTextContainer}>
            <Text style={styles.textStyle}>
              <Text style={styles.textStyle}>
                #17¢ per litre benefit applies when eligible Aura customers
                combine their 3¢ per litre reward with the ‘Coles Supermarkets
                Fuel Docket Discount’ and the ‘Spend $20 get 10¢ per litre fuel
                discount’ made available by Coles Express at Shell Coles Express service
                stations, subject to the Coles Express&nbsp;
              </Text>
              <Text
                style={[styles.textStyle, { textDecorationLine: "underline" }]}
                onPress={() => {
                  Platform.OS !== "web"
                    ? Linking.openURL(
                      "https://www.coles.com.au/coles-express/terms-and-conditions"
                    )
                    : window.open(
                      "https://www.coles.com.au/coles-express/terms-and-conditions",
                      "_blank"
                    );
                }}
              >
                terms and conditions.
              </Text>
              <Text style={styles.textStyle}>
                &nbsp;The 3¢ per litre Aura reward will be redeemed to your Aura
                account approximately 48 hours after purchase. The additional 4¢
                per litre and 10¢ per litre Coles Express offers (where
                applicable) will be discounted from your purchase price at the
                point of sale.
              </Text>
            </Text>
          </View>
           {/* This commented part can be removed in 22/10/23 */}
          {/* <TouchableOpacity
            style={styles.SubmitButtonStyle}
            activeOpacity={0.5}
            onPress={() => {
              if (checked)
                AsyncStorage.setItem("skipShellLandingScreen", "truthy");
              navigation.navigate("ShellBarcode");
            }}
          >
            <Text style={styles.SubmitButtonTextStyle}>REDEEM OFFERf</Text>
          </TouchableOpacity> */}
          <View style={{ marginTop: 25, alignSelf: "center" }}>
            <GenericButton
              buttonText='REDEEM OFFER'
              onPress={() => {
                if (checked)
                  AsyncStorage.setItem("skipShellLandingScreen", "truthy");
                navigation.navigate("ShellBarcode");
              }}
            />
          </View>

          <View style={styles.checkBoxContaier}>
            <Checkbox.Android
              color="#FFC72C"
              status={checked ? "checked" : "unchecked"}
              onPress={() => {
                setChecked(!checked);
              }}
              style={styles.checkBoxStyle}
            />
            <Text style={styles.textStyleDont}>Don't show this page again</Text>
            {/* <Pressable
                        style={[styles.checkboxBase, checked && styles.checkboxChecked]}
                        onPress={onCheckmarkPress}>
                        {checked && <FontAwesome name="check-circle" size={24} color="black" />}
                    </Pressable> 
                   <Text style={styles.textStyle}>
                        Don't show this page again
                    </Text>   */}
          </View>
        </View>
        <View style={GlobalStyles.webFooter}>
          {win.width > 768 ? <FooterBarWide /> : null}
        </View>
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  backButtonContainer: {
    paddingTop: 50,
    flex: 1,
    //paddingLeft: 10
  },
  forwardButtonContainer: {
    paddingTop: 50,
    flex: 1,
    //paddingLeft: 10
  },
  mainMenuLogoContainer: {
    flex: 3,
    alignSelf: "center",
    alignItems: "center",
    //paddingRight: 90,
    paddingTop: 30,
    paddingLeft: 10,
  },
  mainMenuLogo: {
    height: 70,
    width: 128,
  },
  bodyContainerFull: {
    flex: 1,
    flexDirection: "column",
    paddingTop: 15,
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    width: "100%",
  },
  fuelPartnerTextContainer: {
    alignItems: "center",
    marginTop: -10,
  },
  fuelPartnerTextStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: "#757575",
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 20,
    marginBottom: 15,
  },
  ShellLogoContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 5,
  },
  shellLogo: {
    height: 58,
    width: 199,
    resizeMode: "contain",
  },
  boldTextContainer: {
    alignItems: "center",
    marginTop: 25,
    marginBottom: 10,
  },
  threeLogoContainer: {
    flexDirection: "row",
    justifyContent: "center",
  },
  saveIconLogo: {
    height: 169,
    width: 356,
    resizeMode: "contain",
  },
  termTextContainer: {
    marginTop: 20,
    alignItems: "center",
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  SubmitButtonStyle: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFC72C",
    borderRadius: 30,
    marginTop: 25,
    marginLeft: 60,
    marginRight: 60,
    alignItems: "center",
    width: 280,
    alignSelf: "center",
  },
  SubmitButtonTextStyle: {
    color: "black",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 16,
    fontWeight: "bold",
  },
  textStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    color: "black",
    textAlign: "center",
    marginBottom: 5,
    maxWidth: 450,
  },

  textStyleBold: {
    fontFamily: "montserrat-bold",
    fontSize: 18,
    color: "black",
    textAlign: "center",
    marginBottom: 5,
    maxWidth: 300,
  },
  textStyleDont: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    color: "black",
    textAlign: "center",
    marginBottom: 5,
    maxWidth: 300,
    marginTop: 5,
  },
  checkBoxContaier: {
    flexDirection: "row",
    marginTop: 25,
    alignSelf: "center",
    alignItems: "center",
  },
  checkBoxStyle: {
    //  borderRadius: 10,
  },
  scrollView: {
    backgroundColor: "#ffffff",
  },
});
